"use client";

import {
	ListItem,
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuList,
	NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import cn from "@/lib/cn";
import Link from "next/link";
import { usePathname } from "next/navigation";

const GrowWithUsMenu = () => {
	const pathname = usePathname();
	const isActive = pathname === "/advertise" || pathname === "/advertise/plans/essential";

	return (
		<NavigationMenu>
			<NavigationMenuList>
				<NavigationMenuItem>
					<NavigationMenuTrigger className={cn(isActive ? "text-brand-primary" : "text-gray-700")}>
						<Link
							href="/marketing"
							className={cn("z-10 rounded-md text-sm font-normal hover:text-brand-primary")}
						>
							Grow With Us
						</Link>
					</NavigationMenuTrigger>
					<NavigationMenuContent>
						<ul className="grid gap-1 bg-white p-4">
							<ListItem title="Grow With Us" href="/marketing" />
							<ListItem title="Submit press release" href="/news/press-release" />
							<ListItem title="About Us" href="/about-us" />
							<ListItem title="How it works?" href="/how-it-works" />
							<ListItem title="Developer Funding Solutions" href="/services/oneNDF" />
							<ListItem title="Customer Education Portal" href="/services/customer-education-portal" />
							<ListItem title="PTB Labs" href="/ptb-labs" />
							<ListItem title="US Goto Market" href="/ptb-labs-us" />
							<ListItem title="Contact Us" href="/contact-us" />
						</ul>
					</NavigationMenuContent>
				</NavigationMenuItem>
			</NavigationMenuList>
		</NavigationMenu>
	);
};

export default GrowWithUsMenu;
